"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("ellipse", { cx: "18", cy: "7", rx: "16", ry: "5" }),
  React.createElement("path", { d: "M18 24.275c-4.936 0-14.212-1.169-16-4V29c0 2.761 7.163 5 16 5s16-2.239 16-5v-8.73c-2.447 3.095-11.064 4.005-16 4.005z" }),
  React.createElement("path", { d: "M18 14.275c-4.936 0-14.212-1.169-16-4V17c0 2.761 7.163 5 16 5s16-2.239 16-5v-6.73c-2.447 3.095-11.064 4.005-16 4.005z" })
);

